/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputText from "components/ui/input/InputText";

import { mailAddressValidationCheck } from "../../utilities/validation";

/**
 * メールアドレス
 * @param {String} label ラベル
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} maxLength 最大文字数
 * @param {Object} matchValid バリデーション一致判定用オブジェクト
 * @param {String} txtCaption 注釈
 */
const MailAddress = memo(({ label, required, name, maxLength, matchValid, txtCaption }) => {
  return (
    <>
      <div css={mtgGroup}>
        {/** ラベル */}
        <LabelWithOptionIcon required={required}>
          {label}
        </LabelWithOptionIcon>
        <InputText
          name={name}
          placeholder="tokyogas@exmaple.co.jp"
          rules={{
            required: {
              value: required,
              message: "メールアドレスを入力してください。",
            }
          }}
          mailAddressValid={{
            mailAddressValidationCheck,
            message: "メールアドレスの形式が正しくありません。",
          }}
          maxLength={maxLength}
          matchValid={matchValid}
        ></InputText>
        {/** 注釈 */}
        <p css={mtgCaption}>{txtCaption}</p>
      </div>
    </>
  );
});

export default MailAddress;
